import { render, staticRenderFns } from "./MynaviMsDialog.vue?vue&type=template&id=71b418e2&"
import script from "./MynaviMsDialog.vue?vue&type=script&lang=js&"
export * from "./MynaviMsDialog.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/pages/pages.scss?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/scss/pages/setting.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports